import pathConfig from "../config/requirePath";
const urlPath = {};
urlPath.install = Vue => {
  Vue.directive("url-path", {
    // 当被绑定的元素插入到 DOM 中时……
    inserted: function(el, binding, vnode) {
      // 聚焦元素
      el.href = pathConfig[binding.value]
    }
  });
};

export default urlPath